import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IB2BDocument, IB2BDocumentInitialState } from "./b2bDocumentModel";
import {
  getAllB2BDocument,
  createB2BDocument,
  updateB2BDocument,
  deleteB2BDocument,
  getB2BDocumentByID,
  getAllActiveB2BDocument,
  ActiveInactiveB2BDocument,
} from "./services/b2bDocument.services";

const initialState: IB2BDocumentInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  B2BDocumentList: [],
  B2BDocumentID: null,
  B2BDocumentDetail: {
    ID: null,
    Title: "",
    Remarks: "",
    IsActive: 1,
    Image: "",
  },
};

const b2bDocumentocumentSlice = createSlice({
  name: "b2bDocument",
  initialState,
  reducers: {
    clearB2BDocumentDetails: (state) => {
      state.B2BDocumentDetail = initialState.B2BDocumentDetail;
    },
    setB2BDocumentID: (state, action) => {
      state.B2BDocumentID = action.payload;
    },
    clearB2BDocumentID: (state) => {
      state.B2BDocumentID = initialState.B2BDocumentID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllB2BDocument.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllB2BDocument.fulfilled,
      (state, action: PayloadAction<IB2BDocument[]>) => {
        state.loading = false;
        state.B2BDocumentList = action.payload || [];
      },
    );
    builder.addCase(getAllB2BDocument.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.B2BDocumentList = [];
    });
    builder.addCase(createB2BDocument.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createB2BDocument.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createB2BDocument.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateB2BDocument.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateB2BDocument.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateB2BDocument.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteB2BDocument.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteB2BDocument.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteB2BDocument.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getB2BDocumentByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getB2BDocumentByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.B2BDocumentDetail = action.payload;
    });
    builder.addCase(getB2BDocumentByID.rejected, (state, action) => {
      state.formLoading = false;
      state.B2BDocumentDetail = initialState.B2BDocumentDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveB2BDocument.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveB2BDocument.fulfilled,
      (state, action: PayloadAction<IB2BDocument[]>) => {
        state.loading = false;
        state.B2BDocumentList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveB2BDocument.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.B2BDocumentList = [];
    });
    builder.addCase(ActiveInactiveB2BDocument.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveB2BDocument.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveB2BDocument.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearB2BDocumentDetails, clearB2BDocumentID, setB2BDocumentID } =
  b2bDocumentocumentSlice.actions;
export default b2bDocumentocumentSlice.reducer;
